import { Link } from 'react-router-dom'
import casemi from "../../img/casemi.png";
const Casemi = () => {
      return (
      <div className="section animated fadeIn" style={{ margin: '30px 0' }}>
         {/* BANNER INSTITUCIONAL DE CASEMI */}
         <div className="card-panel bg-latitud z-depth-2" style={{ borderRadius: '12px', padding: '40px 30px', backgroundColor: '#039be5', margin: 0 }}>
            <div className="row valign-wrapper" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', margin: 0 }}>
               
               {/* LOGO CIRCULAR CON CONTENEDOR ELEGANTE */}
               <div className="col s12 m12 l5 x5 center-align" style={{ marginBottom: '20px' }}>
                  <div style={{ display: 'inline-block', padding: '8px', background: 'rgba(255, 255, 255, 0.15)', borderRadius: '50%' }}>
                     <Link to="https://casemi.com.ar/" target="_blank" rel="noopener noreferrer">
                        <img 
                           src={casemi} 
                           alt="CASEMI Jujuy" 
                           className="responsive-img circle" 
                           style={{ width: '140px', height: '140px', objectFit: 'cover', border: '3px solid #ffffff', display: 'block' }} 
                        />
                     </Link>
                  </div>
               </div>

               {/* TEXTO Y BOTÓN DE ACCIÓN */}
               <div className="col s12 m12 l7 x7 white-text center-on-small-only" style={{ paddingLeft: '15px' }}>
                  <h4 style={{ fontWeight: '700', fontSize: '2rem', margin: '0 0 8px 0', letterSpacing: '0.5px' }}>
                     CASEMI
                  </h4>
                  <p style={{ fontSize: '1.15rem', lineHeight: '1.6', margin: '0 0 25px 0', fontWeight: '400', opacity: '0.95' }}>
                     Estamos Asociados a la Cámara de Servicios Mineros de Jujuy.
                  </p>
                  <Link 
                     to="https://casemi.com.ar/" 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     className="btn waves-effect waves-light white grey-text text-darken-3 z-depth-1 hoverable" 
                     style={{ borderRadius: '6px', textTransform: 'none', fontWeight: '600', padding: '0 28px', height: '42px', lineHeight: '42px' }}
                  >
                     Visitar sitio
                     <i className="material-icons right" style={{ fontSize: '1.2rem', marginLeft: '6px' }}>open_in_new</i>
                  </Link>
               </div>
            </div>
         </div>
   </div>
   )
}

export default Casemi